// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"08bb5841","706":"e411c8d8"}[chunkId] + ".chunk.js";
};